import React from "react";
import ReactDOM from "react-dom";

import ModalReportMessage from "shared/components/ModalReportMessage";

/**
 * The controller that mounts and opens the modal.
 *
 * @name ReportMessage
 * @global
 */
const ReportMessage = {
	/**
	 * Creates the modal mount node and appends it to the page.
	 *
	 * @method
	 * @param {Boolean} shouldOpen - Whether or not to open immediately.
	 */
	init(shouldOpen = false) {
		if (!this.$el) {
			this.$el = document.createElement("div");
			this.$el.id = "report_message_modal";
			document.body.appendChild(this.$el);
		}

		if (shouldOpen) {
			this.open();
		}
	},

	/**
	 * Closes the modal. In this case that means unmounting the React component.
	 * It really shouldn't be this way, but we kind of have to because this is a
	 * standalone component, it's not part of a larger app that can maintain an
	 * open/close state.
	 *
	 * @method
	 */
	close() {
		// run this in another thread (otherwise React will complain,
		// because we're running this in an event handler, and the element is removed
		// AFTER the event is handled. yeah i don't really understand either)
		requestAnimationFrame(() => {
			ReactDOM.unmountComponentAtNode(this.$el);
		});
	},

	/**
	 * Opens the React component. If the mount node isn't there, this method will
	 * call init to add it to the page and then run the open method again. It
	 * should just work every time you call it. All properties on the params
	 * object are required.
	 *
	 * @method
	 * @param {Object} params - An object
	 * @param {String} params.userid - OKC userid
	 * @param {String} params.username - OKC username
	 * @param {String} params.msgid - ID of the message
	 * @param {String} params.threadid - ID of the thread. When threadid is provided,
	 * msgid is not needed. Use threadid so flagged threads show up correctly in HRT.
	 */
	open(params = {}) {
		if (!params.userid) {
			console.log("ReportMessage must be called with a userid!");
			return;
		}

		if (!params.username) {
			console.log("ReportMessage must be called with a username!");
			return;
		}

		if (!this.$el) {
			this.init(true);
			return;
		}

		ReactDOM.render(<ModalReportMessage {...params} />, this.$el);
	},
};

// Back to the old school, attach this shit to the window. This kind of has
// to be this way, since this is included in the common bundle.
window.ReportMessage = ReportMessage;

/**
 * And the new school way, for future-friendliness.
 *
 * Exports the report message singleton. Call open with the parameters of the
 * user you want to flag a message for.
 *
 * @exports {Object} ReportMessage
 */
export default ReportMessage;



// WEBPACK FOOTER //
// ./src/shared/util/ReportMessage.js